var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactDetails({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6 12",
    width: 6,
    height: 12,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.84 5.57L0.94 0.18C0.89 0.12 0.83 0.08 0.76 0.05C0.7 0.01 0.62 0 0.55 0C0.48 0 0.4 0.01 0.34 0.05C0.27 0.08 0.21 0.12 0.16 0.18C0.11 0.23 0.07 0.3 0.04 0.38C0.01 0.45 0 0.53 0 0.6C0 0.68 0.01 0.76 0.04 0.83C0.07 0.91 0.11 0.97 0.16 1.03L4.67 6L0.16 10.97C0.11 11.03 0.07 11.09 0.04 11.17C0.01 11.24 0 11.32 0 11.4C0 11.47 0.01 11.55 0.04 11.62C0.07 11.7 0.11 11.77 0.16 11.82C0.21 11.88 0.27 11.92 0.34 11.95C0.4 11.99 0.48 12 0.55 12C0.63 12 0.7 11.99 0.77 11.95C0.83 11.92 0.89 11.88 0.94 11.82L5.84 6.43C5.89 6.37 5.93 6.3 5.96 6.23C5.99 6.16 6 6.08 6 6C6 5.92 5.99 5.84 5.96 5.77C5.93 5.7 5.89 5.63 5.84 5.57Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactDetails);
export default __webpack_public_path__ + "static/media/contactDetails.f1b1feeed5153ac0bc35f1fcdf034c91.svg";
export { ForwardRef as ReactComponent };